import React from "react";
import HiddenBoxNetwork from "./HiddenBoxNetwork";

export default class InnerBox extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            visible: false
        };
        console.log(props.topicId);
        
    }
    handleClick() {
      this.setState((prevState) => {
          return {
              visible: !prevState.visible
          };
      });
  }
  

  render() {
    return (
      <div>
                <button type="button" class="btn bg-light btn-lg btn-block mb-1 py-1" onClick={this.handleClick}>
                    {(this.state.visible) ? "click to HIDE interactions between Twitter users." : "click to SHOW interactions between Twitter users."}
                </button>
                {(this.state.visible) && <HiddenBoxNetwork topicId={this.props.topicId}/>}
            </div>

    );
  }
}





// import React from "react";
// import HiddenBoxNetwork from "./HiddenBoxNetwork";

// import {
//   CardBody,
//   Row, 

// } from "shards-react";

// export default class InnerBoxNetwork extends React.Component {
//     constructor(props) {
//         super(props);
//         console.log(props.topicId);
        
//     }

//   state = {
//     buttonClicked: false
//   };
//   handleClick = () => {
//     this.setState({
//       buttonClicked: !this.state.buttonClicked
//     });
//   };
//   render() {
//     return (
//       // <CardBody> 
//       <div className="mt-0" onDoubleClick={this.handleClick}>
//         {this.props.children}
//         {this.state.buttonClicked && <HiddenBoxNetwork topicId={this.props.topicId}/>}
        
//       </div>
      

//       // </CardBody> 
//     );
//   }
// }
